<template>
 <el-form :rules="rules" ref="exportissueform" :model="exportissueform" label-width="80px">
    <el-form-item :label="$t('exportIssue.company', { msg: 'exportIssue.company' })" prop="companyID">
      <el-col :span="8">
        <el-select style="width: 350px" v-model="exportissueform.companyID" :placeholder="$t('exportIssue.companyS', { msg: 'exportIssue.companyS' })">
          <el-option v-for="item in allusercompany" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-form-item>
    <el-form-item :label="$t('exportIssue.section', { msg: 'exportIssue.section' })" prop="fromDate">
      <el-row>
        <el-col :span="4">
          <el-date-picker
            ref="fromDate"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            v-model="exportissueform.fromDate"
            type="date"
            :placeholder="$t('exportIssue.sDate', { msg: 'exportIssue.sDate' })"
            style="width: 100%"
          />
        </el-col>
        <el-col :span="1" class="date-separator">
          <span>{{ $t('exportIssue.to', { msg: 'exportIssue.to' }) }}</span>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="toDate">
            <el-date-picker
              ref="toDate"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              v-model="exportissueform.toDate"
              type="date"
              :placeholder="$t('exportIssue.eDate', { msg: 'exportIssue.eDate' })"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <el-col :span="8">
        <el-button type="primary" @click="onExportSubmit('exportissueform')">{{ $t('exportIssue.export', { msg: 'exportIssue.export' }) }}</el-button>
      </el-col>
    </el-form-item>
  </el-form>
</template>

<script>
import {getusercompany} from "@/axios";
import {baseUrl_New} from "@/axios/urlconfig";

export default {
  name: "exportissue",
  props:['userid','username','realname','role','companyID','usercompany'],
  data(){
    return {
      exportissueform:{
        companyID: [],
        fromDate: '',
        toDate: '',
      },
      allusercompany: [],
      rules: {
        companyID: [
          {required: true, message: this.$t('exportIssue.companyD', { msg: 'exportIssue.companyD' }), trigger: 'change'}
        ],
        fromDate: [
        { required: true, message: this.$t('exportIssue.dateD', { msg: 'exportIssue.dateD' }), trigger: 'blur' }
      ],
        toDate: [
          { required: true, message: this.$t('exportIssue.dateD', { msg: 'exportIssue.dateD' }), trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    this.getUserCompany();
  },
  methods:{
    getUserCompany(){
      getusercompany({
        companyID: this.companyID
      }).then(res=>{
        this.allusercompany.splice(0,this.allusercompany.length);
        for (let i=0 ;i<res.count;i++){
          this.allusercompany.push({text: res.data[i].companyname,label: res.data[i].companyname,value: res.data[i].companyID});
        }
        this.allusercompany.sort(function(a,b){return a.label>b.label ? 1:-1;}); //将公司根据公司名排序
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },
    onExportSubmit(formName){  
      let isAdmin = false;
      if(sessionStorage.getItem('role').includes('超级管理员')){
        isAdmin = true;
      }
      //新增类型
      this.$refs[formName].validate((valid) => {
        if (valid) {
        this.$confirm(this.$t('exportIssue.exportInfo', { msg: 'exportIssue.exportInfo' }),this.$t('exportIssue.mention', { msg: 'exportIssue.mention' }),{
        confirmButtonText: this.$t('exportIssue.confirm', { msg: 'exportIssue.confirm' }),
        cancelButtonText: this.$t('exportIssue.cancel', { msg: 'exportIssue.cancel' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'success'
      }).then(() => {
          const link = document.createElement('a');
          link.style.display = 'none';
          link.setAttribute('href',`${baseUrl_New}/exportissue?companyID=`+this.exportissueform.companyID+'&fromDate='+this.exportissueform.fromDate+ '&toDate='+ this.exportissueform.toDate + '&userId=' + sessionStorage.getItem('userid') + '&isAdmin=' + isAdmin);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        } else {
          console.log('error submit!!');
          return false;
        }

      })

    },
    
  }

}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 20px;
}
.date-separator {
  display: flex;
  /* align-items: center; */
  justify-content: center;
}
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
</style>
